import type { ReactNode } from 'react';
import { RoleGate } from '@/features/auth';
import { Role } from '@/entities/user/model/user.types';
import { ScraperDenied, ScraperTabs } from '@/features/scraper';

/**
 * One gate for the whole section.
 *
 * Workflows puts a `RoleGate` in each page because it has three routes; this has
 * five siblings under a single boundary, and repeating the gate five times is
 * five chances to forget it. A layout wraps every route beneath it and persists
 * across sibling navigations, which is also exactly what the tab bar wants.
 *
 * `RoleGate` is an exact membership test, not the API's hierarchy — so
 * `[Role.SUPER_ADMIN]` here means the same thing `@Roles('SUPER_ADMIN')` means
 * on the resolvers. It is not the enforcement, though: the API refuses anyone
 * else regardless of what the browser renders.
 */
export default function ScraperLayout({ children }: { children: ReactNode }) {
  return (
    <RoleGate roles={[Role.SUPER_ADMIN]} fallback={<ScraperDenied />}>
      <div className="space-y-6">
        <ScraperTabs />
        {children}
      </div>
    </RoleGate>
  );
}
